module.exports = __webpack_public_path__ + "img/11.f1f63c70.png";